import React from 'react'

import { publishEvent } from '@zet/analytics'
import { B4, SH4 } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { i18n } from '@zet/localization'

import ZetLoyalty from '../../assets/svg/zetLoyalty.svg'
import { payoutText } from '../../utils'

const HighestPayoutLoyaltyCard = ({
  setIsBottomSheetVisible,
  tier,
  tierData,
  content,
}: {
  setIsBottomSheetVisible: React.Dispatch<React.SetStateAction<boolean>>
  tierData: any
  tier: any
  content: any
}) => {
  function openBottomSheet() {
    setIsBottomSheetVisible(true)
    publishEvent('click_action', {
      item_name: 'brandpage_payout_knowmore',
      feature: 'highest_payout_discovery',
      brand_name: content?.name,
      category: content?.categoryId,
    })
  }
  return (
    <Pressable
      className="bg-primary-10 flex-row items-center px-3 py-2"
      onPress={openBottomSheet}
    >
      <ZetLoyalty className="mr-2" />
      <B4 numberOfLines={2} className="text-primary-200 flex-1">
        {payoutText(tier, tierData)?.tierText}
        {i18n.locale === 'en' && <SH4>{payoutText(tier, tierData)?.tier}.</SH4>}
        {payoutText(tier, tierData)?.completeSalesText}
        <SH4 className="underline">{i18n.t('brandDetails.knowMore')}</SH4>
      </B4>
    </Pressable>
  )
}

export default HighestPayoutLoyaltyCard
